export var DateMode=/*#__PURE__*/function(a){return a.DAY_MONTH_YEAR="day-month-year",a.MONTH_YEAR="month-year",a}({});